export default (that) => [
    {
      field: 'seq',
      width: 50,
      align: 'center',
      fixed: 'left',
      type: 'seq',
    },
    {
      field: 'defaultImageUrl',
      width: 70,
      title: that.$l('INDEX.table_label_image') || '图片',
      headerAlign: 'left',
      align: 'left',
      slots: { default: 'defaultImageUrl' },
    },
    {
      title: that.$l('INDEX.replenishment_label_goodsName') || '产品名称',
      field: 'goodsName',
      headerAlign: 'left',
      align: 'left',
      minWidth: 220,
      slots: { default: 'displayName' },
    },
  ]
  